<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                title="Payroll Advice List "
                :showAddNew="false"
                :showBtn="true"
                @onClickCloseButton="navigateToListPage"
            />
        </div>

      <div class="my-2 px-2">
        <div class="d-flex justify-content-between">
          <div>
             <h6>Payment Category: {{ paymentModeData.payment_mode_name }}</h6>
             <h6>Total Payable: {{ paymentModeData.total_payable_amount }}</h6>
             <h6>Total Paid: {{ paymentModeData.total_paid_amount }}</h6>
             <h6>Total Due: {{ paymentModeData.total_due_amount }}</h6>
          </div>
        </div>
      </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>Type</th>
                  <th>Voucher No</th>
                  <th>Payment Date</th>
                  <th>Paid Amount</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in payrollData" :key="i">
                  <td>{{ item.type }}</td>
                  <td>{{ item.voucher_no }}</td>
                  <td>{{ item.payment_date }}</td>
                  <td>{{ item.paid_amount }}</td>
                  <td>
                    <button v-if="false" class="btn btn-primary btn-sm me-1"
                            @click="goToShow(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>

                    <button class="btn btn-success btn-sm me-1"
                            @click="exportTable(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-file-export"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="payrollData && payrollData.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import figureFormatter from "@/services/utils/figureFormatter";
import payrollStatementPdf from '@/services/utils/pdf/payrollStatementPdf';
import handleContact from '@/services/modules/contact'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfileId = ref('')
let saveButtonLoader = ref(false)
const payrollData = ref([]);
const paymentModeData = ref('');
const params = ref({
    offset: 20,
});
const { commaFormat } = figureFormatter();
const token = computed(() => localStorage.getItem('token'));
const {
  getPayrollAdviceMasterList
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

const { exportToPDF } = payrollStatementPdf();
const formData = ref({
  payment_date: '',
  payroll_statement_id: route.params.payrollStatementId,
  payment_mode_id: route.params.paymentModeId,
  payments: []
})

const getPayrollData = async () => {
  let query = getQuery();
  let payrollStatementId = route.params.payrollStatementId;

  await getPayrollAdviceMasterList(payrollStatementId, query).then(res => {
    if (!res.status){
      return
    }

    paymentModeData.value = res.data.details;
    payrollData.value = res.data.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const exportTable = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  let url = `${process.env.VUE_APP_BASE_URL}/api/hr-payroll/payroll-advice-master/${item.id}${query}&_token=${token.value}&is_export=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
};

const goToShow = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
    payrollMasterId:item.id,
  }

  let query = route.query;

  router.push({
    name: 'payroll-advice-edit',
    params: param,
    query: query
  })
}

function navigateToListPage() {
  router.push({name: `payroll-process`, params: route.params, query: route.query});
}

function getQuery() {
  let query = `?company_id=${route.params.companyId}&payment_mode_id=${route.params.paymentModeId}`;
  if (contactProfileId.value) query += '&contact_profile_id='+ contactProfileId.value.id
  return query;
}

onMounted(() => {
    Promise.all([
      getPayrollData(),
    ])
})
</script>
